import ziggy from 'ziggy';
import {Ziggy} from './ziggy';

export const route = (name, params, absolute = false) => ziggy(name, params, absolute, Ziggy);
